import { Collapse } from 'bootstrap'
import { trace } from 'rytm-helpers'
import { onNavSoundOpen, onNavSoundClose } from './tsaw-nav-sound'

/**
 * ### INIT ###
 */
export const initTsawHelpers = () => {
  // character MENU show descr (MAIN MENU)
  document.addEventListener("mouseover", onDocMouseover, false)
  document.addEventListener("mouseout", onDocMouseOut, false)
  // click
  document.addEventListener("click", onDocClick, false)
  // keyup (keyboard nav)
  document.addEventListener("keyup", onDocKeyup, false)
  // swipe events
  document.addEventListener("swiped-left", onDocSwipeLeft, false)
  document.addEventListener("swiped-right", onDocSwipeRight, false)
  // Collapse with class toggler
  // chapter nav collapse show / hide (toggle HTML class)
  document.addEventListener("show.bs.collapse", onDocCollapseShow, false)
  document.addEventListener("hidden.bs.collapse", onDocCollapseHidden, false)
}

// ##########################
// ### Doc event handlers ###
// Doc mouse over
const onDocMouseover = (e) => {
  if (e.target.classList.contains("character-menu-item")) {
    const descr = e.target.querySelector(".descr")
    if (descr) {
      const targetSelector = descr.dataset.target
      const target = targetSelector ? document.querySelector(targetSelector) : null
      if (target) {
        target.innerHTML = descr.innerHTML
        target.classList.add("active")
      }
    }
  }
}
// Doc mouse out
const onDocMouseOut = (e) => {
  if (e.target.classList.contains("character-menu-item")) {
    const descr = e.target.querySelector(".descr")
    if (descr) {
      const targetSelector = descr.dataset.target
      const target = targetSelector ? document.querySelector(targetSelector) : null
      if (target) {
        target.classList.remove("active")
      }
    }
  }
}
// doc click
const onDocClick = (e) => {
  // check thumb menu coolapse state
  if (document.documentElement.classList.contains("bottom-menu-open")) {
    const collapseEl = document.querySelector('.collapse[data-tsaw-toggle-class="bottom-menu-open"]')
    // if (collapseEl && !collapseEl.contains(e.target)) {
    if (collapseEl) {
      let collapse = Collapse.getInstance(collapseEl);
      collapse.hide()
    }
  }
}
// Doc Keypress
const onDocKeyup = (e) => {
  const el = document.querySelector(".handle-key-" + e.keyCode)
  if (el) {
    el.click()
  }
}
// swipe left
const onDocSwipeLeft = (e) => {
  // next?
  const el = document.querySelector(".handle-key-39")
  if (el) {
    el.click()
  }
}
// swipe right
const onDocSwipeRight = (e) => {
  // prev?
  const el = document.querySelector(".handle-key-37")
  if (el) {
    el.click()
  }
}
// Doc collapse show
const onDocCollapseShow = (e) => {
  const className = e.target.dataset.tsawToggleClass
  if (className) {
    document.documentElement.classList.add(className)
  }
}
// Doc collapse hidden
const onDocCollapseHidden = (e) => {
  const className = e.target.dataset.tsawToggleClass
  if (className) {
    document.documentElement.classList.remove(className)
  }
}

